import React from "react";
import { Typography, Box } from "@mui/material";
import BaseModal from "./BaseModal";
import GradientButton from "../gradients/GradientButton";
import FrowningFace from "../../assets/frowning-face.png";
import BaseDrawer from "./mobile/BaseDrawer";

const OutOfPointsModal = ({ onClose, setModal, isMobile }) => {
  const Modal = isMobile ? BaseDrawer : BaseModal;

  return (
    <Modal headline="Oh no! You ran out of patch points" onClose={onClose}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <img src={FrowningFace} />
      </Box>
      <Typography sx={{ textAlign: "center", margin: "15px 0px" }}>
        To continue designing, you first need to buy more patch points.
      </Typography>
      <Box sx={{ textAlign: "center" }}>
        <GradientButton onClick={() => setModal({ type: "PURCHASE_POINTS" })}>
          Add Patch Points
        </GradientButton>
      </Box>
    </Modal>
  );
};

export default OutOfPointsModal;
